// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"e07e565a","517":"98572283","676":"8b0319df","683":"be92980d","714":"91dfd0fb","753":"1ce8c3f3","856":"caac9cf0","872":"976b916b"}[chunkId] + ".chunk.js";
};